import { formatTextForDisplay } from '@shared/utils/helpers/format-text-for-display';
import type { TDynamicFilterProps } from '../filter-popover-content/dynamic-filters/dynamic-filter-value-input';
import {
  Filter,
  FilterTrigger,
  FilterValue,
  FilterPlaceholder,
  FilterOptionsList,
  FilterOptionItem,
} from '@src/design-system/filter-new';

export function DynamicSimpleSelectFilter({
  addOrEditDynamicFilter,
  options = [],
  values,
  onChange,
}: TDynamicFilterProps) {
  const hasValues = !!values.length;

  return (
    <Filter>
      <FilterTrigger>
        {hasValues ? (
          <div className='flex items-center flex-wrap gap-1'>
            {values?.map((v) => (
              <FilterValue key={v}>{formatTextForDisplay(v)}</FilterValue>
            ))}
          </div>
        ) : (
          <FilterPlaceholder>Select</FilterPlaceholder>
        )}
      </FilterTrigger>
      <FilterOptionsList align='start'>
        {options.map((opt) => {
          const isSelected = values?.some((v) => v === opt.value);

          return (
            <FilterOptionItem
              key={opt.value}
              selected={isSelected}
              onClick={() => {
                const value = isSelected
                  ? values.filter((v) => v !== opt.value)
                  : [...values, opt.value];

                onChange?.(value);
                addOrEditDynamicFilter?.(value);
              }}
            >
              {formatTextForDisplay(opt.value)}
            </FilterOptionItem>
          );
        })}
      </FilterOptionsList>
    </Filter>
  );
}
